// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"mR-z","inlineTitle":"nR-z","sponsoredAdsWrapper":"oR-z","marketplaceRecosWrapper":"pR-z"};